import React from 'react';
import moment from 'moment';

interface TranscriptPanelProps {
  transcripts: any[];
  missingVSSub: boolean;
  currentTime?: number;
  onTimeChange?: (timestamp: number) => void;
}

const TranscriptPanel: React.FC<TranscriptPanelProps> = ({ 
  transcripts,
  missingVSSub,
  currentTime, 
  onTimeChange 
}) => {
  const formatTimestamp = (timestamp: number) => {
    return moment(timestamp).format('HH:mm:ss');
  };

  const getSpeakerName = (entry: any) => {
    if (entry.speaker === 'agent' || entry.streamType === 'AGENT') {
      return entry.userId ? `Agent ${entry.userId}` : 'Agent';
    }
    return 'Customer';
  };

  const getConfidenceColor = (confidence: number) => {
    if (confidence >= 0.8) return '#28a745'; // Green
    if (confidence >= 0.6) return '#fd7e14'; // Orange
    return '#dc3545'; // Red
  };

  if (!transcripts.length) {
    return (
      <div className="transcript-panel">
        <div className="transcript-header">Transcript Viewer</div>
        <div className="empty-state">
          No transcript available for this call
        </div>
        {missingVSSub && (
          <div className="warning-message">
            The campaign for this call is not Enabled!
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="transcript-panel">
      <div className="transcript-header">
        Transcript Viewer ({transcripts.length} messages)
      </div>
      
      <div className="search-controls">
        <input
          type="text"
          className="search-input"
          placeholder="Search transcript..."
        />
        <button className="btn-secondary">Search</button>
        <button className="btn-secondary">Export</button>
      </div>
      
      <div className="transcript-content">
        {transcripts.map((entry, index) => (
          <div
            key={entry.uuid || index}
            className={`message-container ${(entry.speaker || entry.streamType || 'customer').toLowerCase()}`}
            onClick={() => onTimeChange && onTimeChange(entry.timestamp)}
          >
            <div className="message-timestamp">
              {formatTimestamp(entry.timestamp)}
            </div>
            <div className={`message-bubble ${(entry.speaker || entry.streamType || 'customer').toLowerCase()}`}>
              <div className="message-speaker">
                {getSpeakerName(entry)}
              </div>
              <div className="message-text">
                {entry.text || entry.transcript}
              </div>
              {entry.confidence && (
                <div 
                  className="confidence-indicator"
                  style={{ color: getConfidenceColor(entry.confidence) }}
                >
                  Confidence: {Math.round(entry.confidence * 100)}%
                  {entry.isFinal === false && ' (Interim)'}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TranscriptPanel;
